import { render, staticRenderFns } from "./String.vue?vue&type=template&id=3690c95d&"
import script from "./String.vue?vue&type=script&lang=js&"
export * from "./String.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports